import clsx from 'clsx';

import { type ReactNode } from 'react';

export const Tab = (props: TabProps) => {
  const { id, name, icon, count, active, onTabClick, role = 'tab', ...rest } = props;

  return (
    <li
      key={id}
      role={role}
      aria-selected={active}
      className={clsx({
        active,
      })}
      onClick={onTabClick}
      {...rest}
    >
      {icon}
      <span className="label">{name}</span>
      {!!count && <small className="badge">{count}</small>}
    </li>
  );
};

export interface TabProps {
  id: string;
  name: string;
  role?: string;
  active?: boolean;
  count?: number;
  icon?: ReactNode;
  onTabClick?: () => void;
}
